import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { MenuIcon, XIcon } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white/80 backdrop-blur-md fixed w-full z-50 border-b border-gray-100 top-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold gradient-text">
              Advancecash.io
            </Link>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/#features" className="nav-link">Özellikler</Link>
            <Link to="/#pricing" className="nav-link">Fiyatlar</Link>
            <Link to="/#testimonials" className="nav-link">Referanslar</Link>
            <Link to="/login" className="nav-link">Giriş Yap</Link>
            <Link to="/ultra-admin" className="text-xs text-gray-500 hover:text-gray-700 transition-colors">
              Ultra Admin
            </Link>
            <Link to="/register-company">
              <Button className="btn-primary">
                <span>Başlayın</span>
              </Button>
            </Link>
          </div>
          
          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700 hover:text-gray-900 focus:outline-none"
            >
              {mobileMenuOpen ? (
                <XIcon className="w-6 h-6" />
              ) : (
                <MenuIcon className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-3">
              <Link to="/#features" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Özellikler</Link>
              <Link to="/#pricing" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Fiyatlar</Link>
              <Link to="/#testimonials" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Referanslar</Link>
              <Link to="/login" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Giriş Yap</Link>
              <Link to="/ultra-admin" className="text-xs text-gray-500 hover:text-gray-700" onClick={() => setMobileMenuOpen(false)}>
                Ultra Admin
              </Link>
              <Link to="/register-company">
                <Button className="btn-primary w-full" onClick={() => setMobileMenuOpen(false)}>
                  Başlayın
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
